import React from 'react';
import Botao from './Botao';

/**
 * Escolhas — pílulas de filtro. Marcar uma não desmarca as outras (várias ao mesmo tempo).
 * opcoes: [{ valor, rotulo, contagem?, icone? }]. selecionados: array de valores.
 */
export default function Escolhas({ opcoes, selecionados = [], onMudar, rotulo = 'Filtros' }) {
  const alternar = (valor) => {
    const marcado = selecionados.includes(valor);
    onMudar?.(marcado ? selecionados.filter((v) => v !== valor) : [...selecionados, valor]);
  };

  return (
    <div className="sj-escolhas" role="group" aria-label={rotulo}>
      {opcoes.map((o) => {
        const marcado = selecionados.includes(o.valor);
        return (
          <Botao key={o.valor} pilula aria-pressed={marcado} onClick={() => alternar(o.valor)}>
            {o.icone && <span className="sj-icone" aria-hidden="true">{o.icone}</span>}
            {o.rotulo}
            {o.contagem != null && <span className="sj-escolha__contagem">{o.contagem}</span>}
          </Botao>
        );
      })}
    </div>
  );
}
